import { useQuery } from '@tanstack/react-query';

import type { ClientCertificateByCodeResponse } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const CLIENT_CERTIFICATES_LIST_QUERY_KEY = 'client_certificates';

export const CLIENT_CERTIFICATE_BY_CODE_QUERY_KEY =
  'client_certificate_by_code';

export const useClientCertificateByCodeQuery = (
  url: string,
  code: string,
  isEnabled = false,
) =>
  useQuery({
    queryKey: [CLIENT_CERTIFICATE_BY_CODE_QUERY_KEY, url, code],
    queryFn: () =>
      HttpClient.request<ClientCertificateByCodeResponse>({
        method: 'GET',
        url,
        params: { code },
      }),
    enabled: isEnabled,
    refetchOnWindowFocus: false,
    gcTime: 0,
    staleTime: 0,
    retry: false,
  });
